<template>
  <VcitaMultiLevelMenu data-testid="channel-selector"
                       :activator-icon="defaultChannel.icon"
                       :items="channels"
                       @click="updateChannel"/>
</template>

<script>

import VcitaMultiLevelMenu from "../../../common/components/VcitaMultiLevelMenu/VcitaMultiLevelMenu";

export default {
  name: 'ChannelSelector',
  components: {VcitaMultiLevelMenu},
  props: {
    currentChannel: {
      type: String,
      required: true
    },
    channels: {
      type: Array,
      required: true
    },
    isSmsAvailable: {
      type: Boolean
    },
    isSmsEnabled: {
      type: Boolean
    },
    isMobile: {
      type: Boolean
    }
  },
  computed: {
    defaultChannel() {
      return this.channels.find(channel => channel.value === this.currentChannel) || {}
    }
  },
  methods: {
    updateChannel(channel) {
      if(channel.value === 'sms' && !this.isSmsEnabled) {
        this.$frontageApi.send('conversation-channels')
      } else if(channel.active === 'inactive') {
        return
      } else {
        this.$emit('click', channel)
      }
    },
  }
}
</script>
